import { all } from "redux-saga/effects";
import { getFreeGatesWatcher } from "./freeGates";
import { getOrdersWatcher } from "./orders";
import { authenticationWatcher } from "./authentication";
import { getAuthorizationWatcher } from "./authorization";
import { reconcileWatcher } from "./reconcile";
import { schedulingWatcher } from "./scheduling"
import { getReport } from "./relatorio";
import { conciliationResultWatcher } from "./conciliationResult";
import { getTagWatcher } from "./tag";
import { conciliationSealtWatcher } from "./conciliationSeal";
import { getLoadWatcher } from "./load";
import { getLoadOrdersWatcher } from "./ordersModal";
import { getCdsWatcher } from "./cdList";
import { getCdDetailsWatcher } from "./cdDetails";
import { getCdGatesWatcher } from "./cdGates";
import { getCdExceptionsWatcher } from "./cdExceptions";
import { getPrinterWatcher } from "./printer";
import { getMeasurementChart } from "./measurementChart";
import { getRegisterWatcher } from "./register"
import { getGateVariationWatcher } from "./gateVariations";
import { sustainabilityWatcher} from "./sustainability"
import { providerWatcher} from "./provider"
import { producerDeclarationWatcher } from "./producerDeclaration"
import { preSchedulingWatcher } from "./preScheduling"
import { conciliationReportWatcher } from "./conciliationReport"
import { subcontractorWatcher } from "./subcontractor"
import { orderSampleWatcher } from "./orderSample"
import { idgfPowerBiWatcher } from "./idgfPowerBi"
import { originCertificateWatcher } from "./originCertificate"

export default function* rootSaga() {
    yield all([
        getFreeGatesWatcher(),
        getOrdersWatcher(),
        authenticationWatcher(),
        getAuthorizationWatcher(),
        reconcileWatcher(),
        schedulingWatcher(),
        getReport(),
        getTagWatcher(),
        conciliationResultWatcher(),
        conciliationSealtWatcher(),
        getLoadWatcher(),
        getLoadOrdersWatcher(),
        getCdsWatcher(),
        getCdDetailsWatcher(),
        getCdGatesWatcher(),
        getCdExceptionsWatcher(),
        getPrinterWatcher(),
        getMeasurementChart(),
        getRegisterWatcher(),
        getGateVariationWatcher(),
        sustainabilityWatcher(),
        providerWatcher(),
        producerDeclarationWatcher(),
        preSchedulingWatcher(),
        conciliationReportWatcher(),
        subcontractorWatcher(),
        orderSampleWatcher(),
        idgfPowerBiWatcher(),
        originCertificateWatcher()
    ]);
}
